import { ReactNode } from 'react';
import InternalNote from 'components/layout/internal-note';
import { ValidSystemsDeadEndType } from 'types/dead-end';
import { deadEndCopyFor } from 'utils/dead-end-copy';

type DeadEndStateProps = {
  // The response's deadEnd diagnosis as the store holds it (spec 001 T002):
  // codes and facts only, reason already normalized to the closed union by
  // setDeadEndForConfig. deadEndCopyFor turns it into this component's
  // title and hint — the GUI owns every word the customer reads. Whether
  // the list is in a dead-end state at all is the caller's decision.
  deadEnd: ValidSystemsDeadEndType;
  // Slot for the recovery / consultant-handoff actions (T007-T008 attach
  // them per reason); rendered only when a caller passes one.
  actions?: ReactNode;
};

// Reason-aware empty state (spec 001 T003): a plain-English title and hint
// per reason code, and a slot for actions. Composes InternalNote as a live
// region so the yellow notice box and its icon stay the one copy. Rendered
// by DuctlessSystemsGrid (T004) in place of the generic "No systems match
// your filters." note whenever the build itself produced nothing for the
// shown configurations (deadEndForConfigs).
export default function DeadEndState({ deadEnd, actions }: DeadEndStateProps) {
  const { title, hint } = deadEndCopyFor(deadEnd);

  return (
    <InternalNote live>
      <div className='flex flex-col gap-2'>
        <p className='font-medium'>{title}</p>
        <p>{hint}</p>
        {actions ? (
          <div className='flex flex-wrap items-center gap-2'>{actions}</div>
        ) : null}
      </div>
    </InternalNote>
  );
}
